import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import EditModal from 'components/UI/EditModal';
import Table from 'components/UI/Table';
import TableBody from 'components/UI/Table/TableBody';
import TableRow from 'components/UI/Table/TableRow';
import TableBodyCell from 'components/UI/Table/TableBodyCell';
import TableHeader from 'components/UI/Table/TableHeader';
import TableHeaderCell from 'components/UI/Table/TableHeaderCell';

type Props = {
  open: boolean;
  onClose: () => void;
  desiredData: Record<string, any>;
};

const ViewDesiredModal: FC<Props> = ({ open, onClose, desiredData }) => {
  return (
    <EditModal
      title={'connectivity.view_desired_btn'}
      open={open}
      close={onClose}
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>
              <FormattedMessage id="connectivity.desired_resources" />
            </TableHeaderCell>
            <TableHeaderCell>
              <FormattedMessage id="connectivity.desired_value" />
            </TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {Object.entries(desiredData).map(([, value], index) => (
            <TableRow key={index}>
              <TableBodyCell name="key" value={value.resourceId} />
              <TableBodyCell
                name="value"
                value={
                  typeof value === 'object'
                    ? JSON.stringify(value.value, null, 2)
                    : String(value)
                }
              />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </EditModal>
  );
};

export default ViewDesiredModal;
